<h1 mat-dialog-title>Exit Without Saving?</h1>
<mat-dialog-content>
    <p>Your data will not be saved, consider saving before exit.</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close cdkFocusInitial>Cancel</button>
    <button mat-button [mat-dialog-close]="true">Exit</button>
</mat-dialog-actions>